const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/agentic-insights/experimental/loop-intelligence-1.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
import { loopIntelligenceSearchSchema } from '@/features/agentic-insights/components/experimental/loop-intelligence-1/data/searchState';
import { agenticInsightsBeforeLoad } from '../index';

/**
 * Intelligence #1 — the same run and the same product decisions as the briefing variants, drawn in
 * the Loop Intelligence feed's aesthetic. Its own line of variants rather than the next briefing: it
 * is an alternative to them, not their successor, and it has its own URL so they can be opened side
 * by side.
 */
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/agentic-insights/experimental/loop-intelligence-1')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: agenticInsightsBeforeLoad,
  validateSearch: search => loopIntelligenceSearchSchema.parse(search),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.agenticInsights.title)
    }
  }
});